"use client";


import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import LocationInput, { NoteLocation } from './LocationInput';
import { useToast } from '@/components/ui/use-toast';

interface LocationSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  initial?: NoteLocation | null;
  saving?: boolean;
  onSave: (loc: NoteLocation | null) => Promise<void> | void;
}



export default function LocationSelectorModal({ isOpen, onClose, title = 'Seleccionar ubicación', description, initial = null, saving = false, onSave }: LocationSelectorModalProps) {
  const [value, setValue] = useState<NoteLocation | null>(initial);
  // ...existing code...

  useEffect(() => { setValue(initial); }, [initial, isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={(o)=>{ if(!o) onClose(); }}>
      <DialogContent aria-labelledby="location-selector-title">
        <DialogHeader>
          <DialogTitle id="location-selector-title">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        <div className="py-2">
          <LocationInput value={value} onChange={setValue} showLabel={false} />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => { onClose(); }}>Cancelar</Button>
          <Button className="ml-2" onClick={async () => { await onSave(value); }} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
